import { styled } from '@withjoy/joykit';

export const StyledProgressBar = styled.div<{ value: number }>`
  width: 360px;
  height: 4px;
  border-radius: 2px;
  background-color: ${props => props.theme.colors.gray3};
  position: relative;

  ::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    transition: width 0.5s;
    width: ${props => props.value * 100}%;
    background-color: ${props => props.theme.colors.gray10};
    border-radius: 2px;
  }
`;
